export const MOBILE_TABLET_ID = 269;
export const HOME_AND_LIFESTYLE_ID = 40;
export const ELECTRONICS_AND_APPLIANCES_ID = 247;
export const DEFAULT_CHAT_IMAGE = '/default_images/default_chat_adimg.jpg';
export const RE_RESIDENTIAL_FOR_SALE_SUBCATS = ['31', '38', '39', '271', '287'];
export const BAZAAR_CATS = [MOBILE_TABLET_ID, HOME_AND_LIFESTYLE_ID, ELECTRONICS_AND_APPLIANCES_ID];
